<template>
  <div>
    <AdminNav></AdminNav>
    <div class="container">
      <div class="panel-body">
        <div v-if="rows">
          <vue-good-table
            title="Outfits"
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: true,
            }"
            :pagination-options="{
              enabled: true,
              perPage: 10,
            }">
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {outfits} from "../../firebaseConfig";
  import AdminNav from '@/components/AdminNav'
  export default {
    name: 'Outfits',
    components:{
      AdminNav
    },
    data() {
      return {
        columns: [
          {
            label: 'Outfit',
            field: 'name',
            filterable: true,
          },
          {
            label: 'Children',
            field: 'articleKeys',
            filterable: true,
          },
          {
            label: 'Type',
            field: 'subType',
            filterable: true,
          },
          {
            label: 'Image',
            field: 'imageURL',
          },
        ],
        rows:[]
      }
    },
    firebase: {
      rows:{
        source: outfits.limitToLast(150),
        cancelCallBack(err) {
          console.error(err)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .article-image{
    /* Safari */
    -webkit-transform: rotate(90deg);

    /* Firefox */
    -moz-transform: rotate(90deg);

    /* IE */
    -ms-transform: rotate(90deg);

    /* Opera */
    -o-transform: rotate(90deg);

    /* Internet Explorer */
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }
</style>
